import { Trans, useTranslation } from '@packlink/translation-provider';
import { Button, DialogActions, DialogContent, Typography } from '@shipengine/giger';
import {
    getCancellationActionsStyles,
    getCancellationSuccessDialogStyles,
    getImageStyles,
    getMessageStyles,
} from '@Subscriptions/components/CancelDialog/CancelDialogStyles';

interface RetentionDiscountSuccessProps {
    close: () => void;
    discountedPrice: number;
    startDate: string;
    fullPrice: number;
}

export function RetentionDiscountSuccess({
    close,
    discountedPrice,
    startDate,
    fullPrice,
}: RetentionDiscountSuccessProps): JSX.Element {
    const { t } = useTranslation();
    const {
        cdn: { url: cdnUrl },
    } = config;
    return (
        <>
            <DialogContent css={getCancellationSuccessDialogStyles}>
                <img
                    css={getImageStyles}
                    src={`${cdnUrl}/subscriptions/images/check.svg`}
                    alt={t('subscriptions.cancellation-offer.title')}
                    aria-hidden="true"
                    data-id="cancel-img"
                />
                <Typography css={getMessageStyles} variant="body1" component="p">
                    <Trans
                        i18nKey={'subscriptions.cancellation-offer-success.text'}
                        values={{
                            discountedPrice: discountedPrice,
                            startDate: startDate,
                            fullPrice: fullPrice,
                        }}
                        components={[<strong key="bold" />]}
                    ></Trans>
                </Typography>
            </DialogContent>
            <DialogActions css={getCancellationActionsStyles}>
                <Button onClick={close}>{t('subscriptions.cancellation-offer-success.done')}</Button>
            </DialogActions>
        </>
    );
}
